module.exports = __webpack_public_path__ + "img/card4.84461e16.png";